import React, { Component } from 'react';
// import AppSetting from './all_settings';
import MakerCheckerList from './maker_checker_list';

class MakerCheckerSetting extends Component {
  render() {
    return (<MakerCheckerList
    history={this.props.history}
    location={this.props.location}
    />);
  }
}

export default MakerCheckerSetting;
